
import CaseStudy, { CASE_STUDY_TYPES } from '../../../components/case-study/CaseStudy';
import Header from '../../../components/Header';
import Layout from '../../../components/Layout';
import ThumbnailImage from '../../../images/thumbnails/ifeat_thumbnail.png';

export function Index() {
  return (
    <Layout 
    title="How IFEAT created a branded, high-touch attendee experience with Premagic"
    description="IFEAT (International Federation of Essential Oils and Aroma Trades) is a global network of professionals across the fragrance and flavour supply chain."
    metaImage={ThumbnailImage}
    >
      <Header />
      <CaseStudy type={CASE_STUDY_TYPES.IFEAT} />
    </Layout>
  );
}

export default Index;